<template>
	<section class="other_page_banner commission_main banner_nxt_sec_touch">
		<div class="container">
			<div class="row">
				<div class="col-sm-7 order-2 order-md-1">
					<div class="ban_lt">
						<h5>
							{{
								$t('new_ui.personal_commission_page.section_banner.title.one')
							}}
						</h5>
						<h2>
							{{
								$t(
									'new_ui.personal_commission_page.section_banner.main_title.one',
								)
							}}
						</h2>
						<p>
							{{
								$t(
									'new_ui.personal_commission_page.section_banner.paragraph.one',
								)
							}}
						</p>

						<div
							class="ban_lt_btn d-flex justify-content-start align-items-center p-top"
						></div>
					</div>
				</div>
				<div class="col-sm-5 order-1 order-md-2">
					<div class="ban_rt commission_sec">
						<img :src="img.image1" alt="Logo" />
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="question_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-4 question_desk">
					<div class="question_lt">
						<img :src="img.image2" alt="" />
					</div>
				</div>
				<div class="col-sm-4 question_mob">
					<div class="question_lt">
						<img :src="img.image4" alt="" />
					</div>
				</div>
				<div class="col-sm-8">
					<div class="question_rt">
						<div class="payment_world_right">
							<span>{{
								$t('new_ui.personal_commission_page.question_sec.label')
							}}</span>
							<div class="payment_world_txt">
								<h4>
									{{
										$t('new_ui.personal_commission_page.question_sec.title.one')
									}}
									<span
										>{{
											$t(
												'new_ui.personal_commission_page.question_sec.title.two',
											)
										}}
									</span>
									{{
										$t(
											'new_ui.personal_commission_page.question_sec.title.three',
										)
									}}
								</h4>
								<p>
									{{
										$t(
											'new_ui.personal_commission_page.question_sec.paragraph.one',
										)
									}}
								</p>
								<div class="starting_to_btn pay_world">
									<a href="/auth/register">{{
										$t(
											'new_ui.personal_commission_page.question_sec.cta_button.one',
										)
									}}</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>

	<section class="commi_platfrom">
		<div class="container">
			<div class="row">
				<div class="col-sm-12">
					<div class="commi_platfrom_inn">
						<span>{{
							$t('new_ui.personal_commission_page.commi_platfrom.label')
						}}</span>
						<h5>
							{{
								$t('new_ui.personal_commission_page.commi_platfrom.title.one')
							}}
							<span>{{
								$t('new_ui.personal_commission_page.commi_platfrom.title.two')
							}}</span>
						</h5>
						<div class="commi_platfrom_btm">
							<div class="commi_platfrom_btm1">
								<p>
									{{
										$t(
											'new_ui.personal_commission_page.commi_platfrom.paragraph.one',
										)
									}}
								</p>
								<p>
									{{
										$t(
											'new_ui.personal_commission_page.commi_platfrom.paragraph.two',
										)
									}}
								</p>
							</div>
							<div class="commi_platfrom_btm2">
								<img :src="img.image3" alt="" />
							</div>
							<div class="commi_platfrom_btm1">
								<p>
									{{
										$t(
											'new_ui.personal_commission_page.commi_platfrom.paragraph.three',
										)
									}}
								</p>
								<p>
									{{
										$t(
											'new_ui.personal_commission_page.commi_platfrom.paragraph.four',
										)
									}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="newsletter_sec">
		<div class="container">
			<div class="row">
				<div class="col-sm-12 col-xxl-5 col-xl-5 col-lg-5 col-md-12">
					<div class="newsletter_lt">
						<span>{{
							$t('new_ui.personal_commission_page.section_newsletter.label')
						}}</span>
						<div class="newsletter_txt">
							<h4>
								<span>{{
									$t(
										'new_ui.personal_commission_page.section_newsletter.title.one',
									)
								}}</span>
								{{
									$t(
										'new_ui.personal_commission_page.section_newsletter.title.two',
									)
								}}
							</h4>
						</div>
					</div>
				</div>
				<div class="col-sm-12 col-xxl-7 col-xl-7 col-lg-7 col-md-12">
					<div class="newsletter_rt">
						<p>
							{{
								$t(
									'new_ui.personal_commission_page.section_newsletter.description.one',
								)
							}}
						</p>
						<form>
							<div class="news_mail">
								<div class="news_mail_lt">
									<input
										type="email"
										:placeholder="
											$t(
												'new_ui.personal_commission_page.section_newsletter.form.placeholder',
											)
										"
									/>
								</div>
								<div class="news_mail_rt">
									<button type="submit" value="submit">
										{{
											$t(
												'new_ui.personal_commission_page.section_newsletter.form.button',
											)
										}}
									</button>
								</div>
							</div>
						</form>
						<p class="mt-3">
							{{
								$t(
									'new_ui.personal_commission_page.section_newsletter.description.two',
								)
							}}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import commiban from '@/assets/images/sub/commi_ban.png';
import commidiagram from '@/assets/images/sub/commi_diagram.png';
import comimiddle from '@/assets/images/sub/comiMiddle.png';
import commimobdia from '@/assets/images/sub/commi_mob_dia.png';

export default {
	data: () => {
		return {
			img: {
				image1: commiban,
				image2: commidiagram,
				image3: comimiddle,
				image4: commimobdia,
			},
		};
	},
};
</script>
